import { plainContent } from './plainContent';
import { parseMarkdown } from '../../packages/plugin-shared/documentMarkdown.mjs';
import DOMPurify from 'dompurify';

/** Markdown → sanitized HTML: `marked`, then `DOMPurify`. The one pipeline for text the app writes
 *  into the document as HTML — the chat transcript and, through the plugin runtime, bundles that
 *  render authored notes. Sanitizing is what keeps a pasted snippet from becoming script on the page. */
export function markdownDocument(text: string): HTMLElement {
  return DOMPurify.sanitize(parseMarkdown(plainContent(text, 'preserve')), { RETURN_DOM: true }) as HTMLBodyElement;
}

export function renderMarkdown(text: string): string {
  return markdownDocument(text).innerHTML;
}

/** Markdown → one line of plain text for a search snippet: the same parse, read back as text from an
 *  inert document (`DOMParser` loads no image and runs nothing), so `**Settings**` reads as Settings. */
export function markdownSnippet(text: string): string {
  return new DOMParser().parseFromString(renderMarkdown(text), 'text/html').body.textContent.replace(/\s+/g, ' ').trim();
}
